import { apiGet, apiPost } from "../utils/api";

class ChannelEventsService {
  /**
   * Récupère tous les événements de chaîne
   * @param {Object} options - Options de pagination et filtrage
   * @param {number} options.limit - Nombre de résultats
   * @param {number} options.offset - Offset pour la pagination
   * @param {string|string[]} options.type - Type ou liste de types à filtrer (follow, sub, resub, giftsub, unfollow)
   * @returns {Promise<Object>} Liste des événements
   */
  async getChannelEvents({ limit = 50, offset = 0, type = null } = {}) {
    try {
      const params = new URLSearchParams({ limit, offset });
      if (type) {
        const typeParam = Array.isArray(type) ? type.join(",") : type;
        params.append("type", typeParam);
      }

      const endpoint = `/twitch/channel-events?${params.toString()}`;
      const response = await apiGet(endpoint);
      return response;
    } catch (error) {
      console.error("Erreur lors de la récupération des événements:", error);
      throw error;
    }
  }

  /**
   * Récupère les statistiques des événements
   * @param {number} days - Nombre de jours à analyser
   * @returns {Promise<Object>} Statistiques des événements
   */
  async getStats(days = 30) {
    try {
      const endpoint = `/twitch/channel-events/stats?days=${days}`;
      const response = await apiGet(endpoint);
      return response;
    } catch (error) {
      console.error("Erreur lors de la récupération des statistiques:", error);
      throw error;
    }
  }

  /**
   * Liste des viewers ayant unfollow puis refollow (dernier état = follow, unfollow enregistré en base).
   * @param {Object} [options]
   * @param {string} [options.broadcasterId] - Chaîne Twitch (défaut : chaîne du compte connecté)
   * @param {number} [options.limit]
   * @param {number} [options.offset]
   * @returns {Promise<Object>}
   */
  async getRefollowers({ broadcasterId, limit = 50, offset = 0 } = {}) {
    try {
      const params = new URLSearchParams({
        limit: String(limit),
        offset: String(offset),
      });
      if (broadcasterId) {
        params.append("broadcasterId", broadcasterId);
      }
      const endpoint = `/twitch/channel-events/refollowers?${params.toString()}`;
      return await apiGet(endpoint);
    } catch (error) {
      console.error("Erreur lors de la récupération des refollows:", error);
      throw error;
    }
  }

  /**
   * Synchronise les follows historiques depuis l'API Twitch
   * @param {number} limit - Nombre maximum de follows à synchroniser
   * @returns {Promise<Object>} Résultat de la synchronisation
   */
  async syncFollows(limit = 100) {
    try {
      const response = await apiPost(
        "/twitch/channel-events/sync-follows",
        {
          limit,
        }
      );
      return response;
    } catch (error) {
      console.error("Erreur lors de la synchronisation des follows:", error);
      throw error;
    }
  }

  /**
   * Détecte et enregistre les unfollows
   * @returns {Promise<Object>} Résultat de la détection
   */
  async detectUnfollows() {
    try {
      const response = await apiPost(
        "/twitch/channel-events/detect-unfollows"
      );
      return response;
    } catch (error) {
      console.error("Erreur lors de la détection des unfollows:", error);
      throw error;
    }
  }
}

const channelEventsService = new ChannelEventsService();
export default channelEventsService;
